var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"success","outline":"","disabled":_vm.locked},on:{"click":function($event){return _vm.uploadItemDraft()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-content-save-outline")]),_vm._v("SAVE ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }